import React, {  useMemo, useRef, useState, useEffect } from 'react';
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from 'react-router-dom';
import ComFunction from "../components/ComFunction";
import AGFunction from "../components/AGFunction";
import MasterBase from "../components/MasterLayout";
import EntryBase from "../components/EntryBase";
import EntryGrid from "../components/EntryGrid";
import EntrySetting from "../components/EntrySetting";
import DataTree from "../components/DataTree";
import Headline from "../components/Headline";
import Box from '@material-ui/core/Box';
import Button from '@material-ui/core/Button';
import Paper from '@material-ui/core/Paper';
import {
    isEnabled, isEmpty, getformid, getcontroller, getsubkey,  getWindowDimensions, setglobaldata,
     NumConv, DicVal,  GetDesitRound,  getglobaldata, 
    DeepCopy, initializedata, RandomKey, Savestorage, Getstorage
} from '../modules/appLibrary';
import { arrayMove } from 'react-sortable-hoc';
import { SortableContainer, SortableElement } from 'react-sortable-hoc';
import Chip from '@material-ui/core/Chip';
import { styled } from '@material-ui/core/styles';
import Icon from '@material-ui/core/Icon';
import IconButton from '@material-ui/core/IconButton';
import Tooltip from '@material-ui/core/Tooltip';
import EntryLayout from '../components/EntryLayout';
import { changestatus, listtabs, entryformlock, entrytriggercall,readonly } from '../modules/formstore';
import { setentrypanel, addentrylayout, setentrylayout, setentrystartup } from '../modules/toolpanelstore';
import Checkbox from '@material-ui/core/Checkbox';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import { makeStyles } from '@material-ui/core/styles';
import TextField from '@material-ui/core/TextField';
import MenuItem from '@mui/material/MenuItem';

const ListItem = styled('li')(({ theme }) => ({
    margin: theme.spacing(0.5),
    listStyle: 'none'
}));
const useStyles = makeStyles((theme) => ({
    label: {
        fontSize: "12px"
    },
}));

export const Calculate = props => {

    const inittabs = [{ label: "材料計算", value: '0' }, { label: "材料計算明細", value: '1' }]
    const panelsdef = [{ id: "0", name: "ヘッダ情報", name2: "Hedder", hide: false },
    { id: "1", name: "製品明細", name2: "Rows", hide: false },
    ]
    const G_id = { BASE: "0", ROW: "1", CALC1: "2", CALC2: "3" }
    const primarykeys = ["d_calc_no", "d_calc_order_calcno"];
    const formid = getformid("Calculate", props.location.search);
    const controller = getcontroller("Calculate", props.location.search);
    const subkey = getsubkey(props.location.search);
    const basenavmenu = [
        { status: "ENTRY FORM", menuid: "datatree", icon: "account_tree", label: "Data Tree" },
        { status: "VIEW", menuid: "excel", icon: "file_download", label: "Excel", title: "現在のシート内容をExcelに出力します" },
        { status: "VIEW", menuid: "sep" },
        { status: "VIEW", menuid: "listdatatree", icon: "account_tree", label: "Data Tree" },
    ]

    const corpkey = useSelector(state => state.user.corpkey);
    const account = useSelector(state => state.user.account);
    const staff = useSelector(state => state.user.accctl);
    const warndescription = useSelector(state => state.form.warndiscription);
    const mainlayout = useSelector(state => state.toolpnl.layouts_et);
    const mainprelayout = useSelector(state => state.toolpnl.prelayout_et);
    const maininitlayout = useSelector(state => state.toolpnl.initlayout_et);
    const themestyle = useSelector(state => state.form.themestyle);
    const AGRef = useRef();
    const fnc = useRef();
    const EntrybodyRef = useRef(null);
    const apiRefrow = useRef({ grid: undefined, column: undefined });
    const apiRefcalc1 = useRef({ grid: undefined, column: undefined });
    const apiRefcalc2 = useRef({ grid: undefined, column: undefined });
    const apirow = apiRefrow.current;
    const apicalc = [apiRefcalc1.current, apiRefcalc2.current];
    const locationstate = useRef(null);    //遷移State
    const classes = useStyles();

    const entrydataRef = useRef(null);    //基本情報データ
    const rowsRef = useRef(null);         //製品明細データ
    const colRef = useRef(null);          //製品明細列情報  
    const calc1Ref = useRef(null);        //原材料計算データ
    const calc2Ref = useRef(null);        //副資材計算データ
    const calcRef = [calc1Ref, calc2Ref];
    const calc1colRef = useRef(null);   　//原材料計算列情報  
    const calc2colRef = useRef(null);   　//副資材計算列情報
    const calccolRef = [calc1colRef, calc2colRef];
    const check1Ref = useRef(null);
    const check2Ref = useRef(null);
    const round1Ref = useRef(null);
    const round2Ref = useRef(null);
    const degitpos1Ref = useRef(null);
    const degitpos2Ref = useRef(null);
    const summaryRef = useRef("0");

    const modifyRef = useRef(false);    //変更フラグ
    const menuinfo = useSelector(state => state.form.menuinfo);
    const formstatus = useSelector(state => state.form.status);
    const formlock = useSelector(state => state.form.entryformlock);
    const [panel, setpanel] = useState(panelsdef);
    const [windowDimensions, setWindowDimensions] = useState(getWindowDimensions());
    const [columninfo, setcolumninfo] = useState(null);     //全カラム情報
    const [columns, setcolumns] = useState(null);
    const [edittingcode, setedittingcode] = useState(null);
    const [textfieldsall, settextfieldsall] = useState([]);
    const [textfields, settextfields] = useState([]);
    const [rowmode, setrowmode] = useState(0);      //0:製品選択 1:材料計算
    const [calckubun, setcalckubun] = useState(0);  //0:すべて 1:原材料 2:副資材
    const [update, setUpdata] = useState(false);
    const [navmenu, setnavmenu] = useState(basenavmenu);
    const [layoutlock, setlayoutlock] = useState(false);
    const [sectionclose, setsectionclose] = useState(false);
    const [round, ] = useState([0, 0]);
    const [degitpos, ] = useState([2, 2]);

    const dispatch = useDispatch();
    const AGFunc = React.forwardRef(AGFunction);
    const ComFunc = React.forwardRef(ComFunction);
    const scrollRef = useRef(null);
    const search = useLocation().search;

    const actionurl = {
        "insert": "calculate/Insert",
        "update": "calculate/Update",
        "delete": "calculate/Delete",
        "saveas": "calculate/SaveAs",
    }


    //動作抑止
    const suppressaction = [
        { type: "0", action: "INSERT" },
        { type: "0", action: "UPDATE" },
        { type: "1", action: "INSERT" },
        { type: "1", action: "UPDATE" }
    ];

    function rerender() {
        setUpdata(update ? false : true);
    }
    function statusKey(id) {
        return formid + "entry_" + id;
    }

    useEffect(() => {
        if (isEmpty(corpkey) || isEmpty(account)) return;
        //ListTabを取得
        fnc.current.postaxios('common/GetListTabs', { "panels": panelsdef, "controller": controller, "subkey": subkey },
            {
                onSuccess: function (data) {
                    setpanel(data.panels);
                    if (data.tabs.length === 0) data.tabs = inittabs
                    dispatch(setentrypanel({
                        layouts: data.layouts, prelayout: data.prelayout,
                        initlayout: data.initlayout.length === 0 ? " " : data.initlayout,
                        fitColumn: data.fitColumn
                    }));
                    setcolumninfo(data.colinfo);
                    setcolumns(data.columns);
                    let fields = data.colinfo.filter(e => e.logpid === G_id.BASE);
                    settextfieldsall(fields);
                    settextfields(data.columns.filter(e => e.logpid === G_id.BASE));
                    //列情報初期化
                    colRef.current = null;
                    calc1colRef.current = null;
                    calc2colRef.current = null;
                    if (data.prelayout) {   //レイアウト復元
                        RestoreLayout(data.panels, fields);
                    }

                    //遷移state取得
                    let state = props.location.state;   //history.push
                    if (isEmpty(state) && !isEmpty(window.history.state)) {
                        if ("status" in window.history.state) {
                            //go back
                            state = window.history.state;
                        }
                    }
                    locationstate.current = state;
                    if (!isEmpty(state)) {
                        if ("code" in state) {
                            clearform();
                            dispatch(changestatus(state.code === "" ? "NEW FORM" : "ENTRY FORM"));
                        }
                    }
                    fnc.current.wait(false);
                }
            });
    }, [search]);

    useEffect(() => {
        function handleResize() {
            setWindowDimensions(getWindowDimensions());
        }

        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    useEffect(() => {
        if (isEmpty(menuinfo.ctrls)) return;
        setlayoutlock(menuinfo.ctrls.indexOf("LOCK2") !== -1);
        setsectionclose(menuinfo.ctrls.indexOf("SECCLOSE") !== -1); //セクションCLOSEボタン
    }, [menuinfo]);


    useEffect(() => {
        if (isEmpty(entrydataRef.current)) return;
    }, [formstatus]);


    //遷移state状態表示
    function callshow() {
        if (locationstate.current.code !== "") {
            Show(undefined, locationstate.current.code)
        }
        locationstate.current = null;   //最初の１度のみ
    }

    function calcprop(idx) {
        return idx===0?{ check: check1Ref.current, round: round1Ref.current, degitpos: degitpos1Ref.current }:
                       { check: check2Ref.current, round: round2Ref.current, degitpos: degitpos2Ref.current };
    }

    function setsliplock(value) {
        dispatch(entryformlock(value));
    }

    function onFirstDataRendered(param, id) {
        if (id === G_id.ROW) {
            apiRefrow.current.grid = param.api;
            apiRefrow.current.column = param.columnApi;
        }
        if (id === G_id.CALC1) {
            apiRefcalc1.current.grid = param.api;
            apiRefcalc1.current.column = param.columnApi;
        }
        if (id === G_id.CALC2) {
            apiRefcalc2.current.grid = param.api;
            apiRefcalc2.current.column = param.columnApi;
            if (!isEmpty(locationstate.current)) {
                //遷移表示
                callshow();
            }
        }
    }

    function MenuQueryAction(action, param) {
        if (action === 'delete' && formstatus === "UPDATE") {
            if (param.tabvalue !== '0') {
                fnc.current.warnmsg("このシートのデータは削除できません");
                return false;
            }
        }
        return true;
    }
    function MenuAction(action, finallycallback, param) {
        LayoutSaveStorage();   //現在レイアウト保持
        if (action === 'save') Save(finallycallback);
        if (action === 'delete') Delete(finallycallback);
        if (action === "clear") {
            clearform(true);
        }
        if (action === 'linkfield') {
            switch (finallycallback.table) {
                case "d_calc":
                    let type = "100";
                    let col = textfields.find(e => e.columnid === finallycallback.field);
                    if (col !== undefined) {
                        type = col.type;
                        let key = finallycallback.field + "_" + type;
                        document.getElementById(key).focus();
                        document.getElementById(key).select();
                    }
                    Jump(G_id.BASE, type);
                    break;
                case "d_calc_row":
                    Jump(G_id.ROW);
                    AGRef.current.SetRowSelect(finallycallback.rowid, finallycallback.field, apirow.grid);
                    break;
                default:
                    break;
            }
        }
        if (action === 'datatree') {
            DataTreeOpen(edittingcode);
        }
        if (action === 'listdatatree') {
            for (let i = 0; i < primarykeys.length; i++) {
                if (primarykeys[i] in param[0]) {
                    setedittingcode(param[0][primarykeys[i]]);
                    DataTreeOpen(param[0][primarykeys[i]]);
                    return;
                }
            }
        }
        function DataTreeOpen(code) {
            fnc.current.postaxios('calculate/GetDataTree', { "code": code },
                {
                    onSuccess: function (data) {
                        fnc.current.wait(false);
                        fnc.current.datatreeopen(data.list);
                    },
                    errmsg: "処理に失敗しました"
                }
            )
        }
    }
    function Show(data, pushcode) {
        let code = "";
        if (data === undefined) {
            if (!isEmpty(pushcode)) {   //history.push
                code = pushcode;    
                setedittingcode(code);
            } else {
                code = edittingcode;    //再表示
            }
        } else {
            setglobaldata("entryrowdata", data);
            if (data !== null) {
                for (let i = 0; i < primarykeys.length; i++) {
                    if (data[primarykeys[i]]) {
                        code = data[primarykeys[i]]; break;
                    }
                }
            }
            setedittingcode(code);
        }
        if (isEmpty(columninfo)) return false;    //読み込み前
        clearform(code==="");
        //データ読み込み
        LoadData(code);
        return true;
    }
    function LoadData(code) {
        if (code === "") return;
        fnc.current.postaxios('calculate/GetData', { "code": code, "colinfo": columninfo, "controller": controller },
            {
                onSuccess: function (data) {
                    try {
                        if (code !== "") {
                            //ViewからのMyField値を引継ぎ
                            let row = getglobaldata("entryrowdata");
                            if (!isEmpty(row)) {
                                if ("d_calc_memo" in row) data.data.d_calc_memo = row.d_calc_memo;
                                if ("d_calc_sticky" in row) data.data.d_calc_sticky = row.d_calc_sticky;
                                if ("d_calc_mytags" in row) data.data.d_calc_mytags = row.d_calc_mytags;
                            }
                            fnc.current.margeMaster(data.master);
                            entrydataRef.current = data.data;
                            summaryRef.current = data.data.d_calc_summary;
                            rowsRef.current = data.row;
                            calc1Ref.current = data.orderrow.filter(e => e.d_calc_order_type === "0");
                            calc2Ref.current = data.orderrow.filter(e => e.d_calc_order_type === "1");
                            setrowmode(1);
                            rerender();
                        }
                        fnc.current.wait(false);
                    } catch (error) {
                        console.log(error);
                        fnc.current.wait(false);
                    }
                },
                onError: function (data) {
                    fnc.current.wait(false);
                    let msg = "処理に失敗しました";
                    if (!isEmpty(data.errDescription)) {
                        msg = data.errDescription;
                    }
                    fnc.current.warnmsg(msg);
                    dispatch(changestatus("VIEW"));
                }
            }
        )
    }


    //----------------------------------------------------------------------------
    //  材料計算
    //----------------------------------------------------------------------------
    function rowmodeChange() {
        storeRowData();
        if (rowmode === 0) {    //製品選択→材料計算
            setrowmode(1);
        } else {                //材料計算→製品選択
            setrowmode(0);
        }
    }
    //明細カラム定義
    function Calculate() {
        storeRowData();
        if (!AGRef.current.ExistValidRow(rowsRef.current, columninfo, colRef.current)) {
            fnc.current.warnmsg("製品明細が存在しません");
            return;
        }
        const paramdata = {
            "controller": formid,
            "colinfo":columninfo,
            "data": entrydataRef.current,
            "rowdata": rowsRef.current,
            "code": formstatus === "ENTRY FORM"?edittingcode:""
        }
        fnc.current.postaxios( "calculate/Calculate", paramdata,
            {
                onSuccess: function (data) {
                    if (data.warning.length === 0) {
                        setrowmode(1);
                        fnc.current.margeMaster(data.master);
                        calc1Ref.current = data.orderrow.filter(e => e.d_calc_order_type === "0");
                        calc2Ref.current = data.orderrow.filter(e => e.d_calc_order_type === "1");
                        rerender();
                    }
                    else {
                        let msg = data.warning.length + "件の制約違反が存在します。";
                        fnc.current.showwarndescription(msg, data.warning);
                        setrowmode(0);
                    }
                    fnc.current.wait(false);
                },
                errmsg: "処理に失敗しました"
            }
        )
    }

    function ColdefSpecial(column) {
        if (formstatus !== "ENTRY FORM") return;
        if (column.field === "d_calc_row_instno" ||
            column.field === "d_calc_row_prodno") {
            //受入されている場合編集不可
            column.editable = function (params) {
                if (params.context.entrylock) return false;
                else
                    return !isEnabled(params.node.data["lockrow"]);
            }
            column.cellStyle = function (params) {
                if (!params.context.entrylock && isEnabled(params.node.data["lockrow"])) {
                    return { backgroundColor: '#eee' };
                } else {
                    return null;
                }
            }
        }
    }
    //行削除前イベント
    function QueryRemoveRow(rows) {
        if (formstatus === "ENTRY FORM") {
            for (let i = 0; i < rows.length; i++) {
                if (isEnabled(rows[i].lockrow)) {
                    if (rows.length === 1) fnc.current.warnmsg("この明細は発注済の為行削除できません");
                    else fnc.current.warnmsg("発注済の明細が含まれている為行削除できません");
                    return false;
                }
            }
        }
        return true;
    }


    function Save(finallycallback) {
        storeRowData();
        let row = rowsRef.current;
        if (!AGRef.current.ExistValidRow(rowsRef.current, columninfo, colRef.current)) {
            fnc.current.warnmsg("有効な製品明細が存在しません");
            return;
        }
        if (calc1Ref.current.length === 0 && calc2Ref.current.length === 0) {
            fnc.current.warnmsg("材料計算データが存在しません");
            return;
        }
        Apply();

        function Apply() {
            if (isEmpty(entrydataRef.current)) entrydataRef.current = {};
            let order = [...calc1Ref.current, ...calc2Ref.current];
            const paramdata = {
                "controller": formid,
                "data": entrydataRef.current,
                "rowdata": row,
                "orderrow":order,
                "colinfo": columninfo,
                "code": edittingcode
            }
            fnc.current.postaxios(formstatus === "ENTRY FORM" ? "calculate/UpdateEntry" : "calculate/InsertEntry", paramdata,
                {
                    onSuccess: function (data) {
                        if (data.warning.length === 0) {
                            fnc.current.modify(false);
                            modifyRef.current = false;
                            fnc.current.success();
                            if (formstatus === "ENTRY FORM") {
                                data.data['rowid'] = Getrowid();    //更新行キー
                                finallycallback(data.data);
                            }
                            if (formstatus !== "ENTRY FORM") {
                                entrydataRef.current["d_calc_no"] = data.request;
                                setedittingcode(data.request);
                                dispatch(changestatus("ENTRY FORM"));
                            }
                        }
                        else {
                            let msg = data.warning.length + "件の制約違反により登録できませんでした。";
                            fnc.current.showwarndescription(msg, data.warning);
                        }
                        fnc.current.wait(false);
                    },
                    errmsg: "登録に失敗しました"
                }
            )
        }
    }

   function Delete(finallycallback) {
       const param = {
           rowdata: [{ "rowid": edittingcode }],
           controller: controller
       }
        fnc.current.postaxios("calculate/Delete", param,
            {
                onSuccess: function (data) {
                    if (data.warning.length === 0) {
                        fnc.current.success();
                        finallycallback(edittingcode, primarykeys);
                    }
                    else {
                        fnc.current.warnmsg(["このデータは削除できません", data.warning[0].message]);
                    }
                    fnc.current.wait(false);
                },
                errmsg: "削除に失敗しました"
            }
        )
    }
    function Getrowid() {
        let data = getglobaldata("entryrowdata");
        if (isEmpty(data)) return "";
        return data.rowid;
    }



    //Basic Data Change
    function ValueChanged(id, value) {
        if (id === "d_calc_kubun") {
            setcalckubun(value);
        }
        if (id === "d_calc_summary") {
            if (summaryRef.current === value) return;
            calc1Ref.current = [];
            calc2Ref.current = [];
            summaryRef.current = value;
            rerender();
        }
        //外部からの参照がある項目
        let col = columninfo.find(e => e.columnid === id);
        if (!isEmpty(col)) {
            if (col.extriggerref) {
                dispatch(entrytriggercall(id));
            }
        }
    }
    //Grid Data Change
    function ChangeCalcValue(idx, params) {
        storeRowData(idx===0?G_id.CALC1: G_id.CALC2);
        if (params.column.colId === "d_calc_order_surplus") {
            CalcQty(idx, params.node);
            CalcRollQty(idx, params.node);
        }
        if (params.column.colId === "d_calc_order_qty") {
            CalcRollQty(idx, params.node);
        }
        storeRowData(idx === 0 ? G_id.CALC1 : G_id.CALC2);
    }
    function CalcQty(idx, node) {
        //let rowidx = node.rowIndex;   Sort時異なる
        let rowidx = calcRef[idx].current.findIndex(e => e.rowid === node.data["rowid"]);   
        if (isEmpty(DicVal(calcRef[idx].current[rowidx], "d_calc_order_code", ""))) return;
        var qty = DicVal(calcRef[idx].current[rowidx],"d_calc_order_rest",0);
        if (NumConv(qty) === 0) {
            node.setDataValue("d_calc_order_qty", 0);
            calcRef[idx].current[rowidx]["d_calc_order_qty"] = 0;
            return;
        }
        var ratio = NumConv(DicVal(calcRef[idx].current[rowidx],"d_calc_order_surplus",0));
        //発注数＝不足数×（1+（余裕率/100））
        var value = qty * (1 + (ratio / 100));
        var round = calcprop(idx).round.value;
        var pos = calcprop(idx).degitpos.value;
        calcRef[idx].current[rowidx]["d_calc_order_qty"] = GetDesitRound(value, round, pos);
        node.setDataValue("d_calc_order_qty", calcRef[idx].current[rowidx]["d_calc_order_qty"]);
    }
    function CalcRollQty(idx, node) {
        //let rowidx = node.rowIndex;   Sort時異なる
        let rowidx = calcRef[idx].current.findIndex(e => e.rowid === node.data["rowid"]);
        var len = NumConv(DicVal(calcRef[idx].current[rowidx], "m_matl_length", 0));
        if (len === 0) return;
        var qty = NumConv(DicVal(calcRef[idx].current[rowidx], "d_calc_order_qty", 0));
        if (qty === 0) {
            node.setDataValue("d_calc_order_rollqty", 0);
            calcRef[idx].current[rowidx]["d_calc_order_rollqty"] = 0;
            return;
        }
        //反数＝発注数÷反長　0.5反単位
        var value = GetDesitRound(qty / len, 2, 1);  //切り上げ　小数第一位
        var degit = NumConv(String(value).split(".")[1]);
        var rollqty = GetDesitRound(value, 0, 0);    //整数       
        if (degit >= 5) rollqty += 1;
        else {
            if (degit !== 0) rollqty += 0.5;
        }
        node.setDataValue("d_calc_order_rollqty", rollqty);
        calcRef[idx].current[rowidx]["d_calc_order_rollqty"] = rollqty;
    }
    function SetQuantity(id) {
        var idx = 0;
        if (id === G_id.CALC2) idx = 1;
        if (calcprop(idx).check.checked) {
            const selectedRows = apicalc[idx].grid.getSelectedRows();
            if (selectedRows.length === 0) {
                fnc.current.warnmsg("発注数を算出する行を選択してください");
                return;
            }
            for (let i = 0; i < selectedRows.length; i++) {
                let node = apicalc[idx].grid.getRowNode(selectedRows[i]["rowid"]);
                CalcQty(idx, node);
                CalcRollQty(idx, node);
            }
        } else {
            //All
            fnc.current.confmsg("全行の発注数を算出します。よろしいですか？", () => exec());
            function exec() {
                apicalc[idx].grid.forEachNodeAfterFilterAndSort(function (node) {
                     CalcQty(idx, node);
                     CalcRollQty(idx, node);
                });
            }
        }
    }

    function ChangeRowValue(params) {
        storeRowData(G_id.Row);
        let rowidx = params.node.rowIndex;
        if (params.column.colId === "d_calc_row_instno" || params.column.colId === "d_calc_row_prodno") {
            if (params.column.colId === "d_req_calc_instno" && params.newValue === "") {
                return;
            }
            if (params.column.colId === "d_calc_row_prodno") {
                //指示番号クリア
                if ("d_calc_row_instno" in rowsRef.current[rowidx])
                    rowsRef.current[rowidx]["d_calc_row_instno"] = "";
            }
        }
    }
    function SetTriggerfield(colid, data, rowNode) {
        if (isEmpty(data)) return;
        if (colid === "d_calc_row_prodno") { //指示番号コピー
            rowNode.setDataValue("d_calc_row_instno", data["d_calc_row_instno"]);
        }
    }
    function RowValueChanged(colid, targets) {
        if (colid === "d_calc_row_instno" || colid === "d_calc_row_prodno") {
            for (let i = 0; i < targets.length; i++) {
                if (colid === "d_calc_row_prodno") {
                    //指示番号クリア
                    targets[i]["d_calc_row_instno"] = "";
                }
                var node = apiRefrow.current.grid.getRowNode(targets[i].rowid);
                if (!isEmpty(node)) {
                    node.setData(targets[i]);
                }
            }
        }
        RowDataChanged();
    }
    //Grid Row Data Change
    function RowDataChanged(priceconv, clientchg, colid) {
        if (isEmpty(apiRefrow.current.grid)) return;
        if (isEmpty(rowsRef.current)) rowsRef.current = [];
    }
    //行データ保持
    function storeRowData(panel) {
        if (panel === undefined || panel === G_id.ROW) {
            rowsRef.current = AGRef.current.GetDatasource(apirow.grid);
        }
        if (panel === undefined || panel === G_id.CALC) {
            calcRef.current = AGRef.current.GetDatasource(apicalc.grid);
        }
    }

    function Jump(id, type) {
        let offset = 0;
        var panelid = "basepanel" + type;
        if (id === G_id.ROW) panelid = 'rowGrid';
        if (id === G_id.FILE) panelid = 'fileGrid';
        if (id === G_id.IMAGE) panelid = 'imagepanel';
        let elem = document.getElementById(panelid);
        if (elem === undefined) return;
        offset = elem.offsetTop - 50;
        EntrybodyRef.current.scrollTop = offset;
    }

    function showpanel(id, type, show) {
        let newpanel = DeepCopy(panel);
        let p = newpanel.find(e => e.id === id && e.type === type);
        p.hide = !show;
        setpanel(newpanel);
    }
    // スクロール位置を保存する
    function saveScrollPos() {
        scrollRef.current = EntrybodyRef.current.scrollTop;
    }
    // スクロール位置を復元する
    function restoreScrollPos() {
        try {
            if (scrollRef.current) EntrybodyRef.current.scrollTop = scrollRef.current;
        } catch { }
    }
    //入力フィールドクリア
    function clearform(newform) {
        setsliplock(false);
        setrowmode(0);
        entrydataRef.current = initializedata(textfieldsall, staff);
        rowsRef.current = [{ rowid: RandomKey() }];
        calcRef[0].current = [{ rowid: RandomKey() }];
        calcRef[1].current = [{ rowid: RandomKey() }];
        fnc.current.modify(false);
        modifyRef.current = false;
        //列情報初期化
        colRef.current = null;
        calc1colRef.current = null;
        calc2colRef.current = null;

        if (isEnabled(newform)) {
            //SQL初期値セット
            fnc.current.postaxios("common/GetInitSqlValue", { colinfo: textfieldsall },
                {
                    onSuccess: function (data) {
                        for (let key in data.returnData) {
                            var col = textfieldsall.find(e => e.columnid === key);
                            if (!isEmpty(col)) col.initvalue = data.returnData[key];
                        }
                        entrydataRef.current = initializedata(textfieldsall, staff);
                        rerender();
                    },
                }, true
            )
        }

    }
    //レイアウト保持
    function LayoutSaveStorage() {
        //列情報保存
        AGRef.current.SaveColState(statusKey(G_id.ROW), EmptyPanel(G_id.ROW) ? null : apirow.column);
        //基本情報保存
        Savestorage(corpkey, account, statusKey(G_id.BASE), textfields);
        //パネルの表示/非表示および並び
        Savestorage(corpkey, account, formid + "panel", panel);
    }
    function EmptyPanel(id, type) {
        try {
            return isEmpty(columns.find(e => e.logpid === id));
        } catch { return false; }
    }
    //パネル別列情報取得
    function tabletype(id) {
        if (id === G_id.CALC1 || id === G_id.CALC2) {  //材料計算
            if (isEmpty(columninfo)) return "";
            let col = columninfo.find(e => e.logpid === id);
            if (isEmpty(col)) return '';
            return col.type;
        } else {
            let pnl = panel.find(e => e.id === id);
            if (isEmpty(pnl)) return '';
            return pnl.type;
        }
    }

    //基本項目設定
    function SetBaseField(type) {
        fnc.current.entrylayoutopen(type);
    }
    //レイアウト復元
    function RestoreLayout(panels, fields) {
        //パネルの並び
        RestorePanel(panels);
        //基本情報
        RestoreBase(fields)
    }
    function RestorePanel(panel) {
        let paneldata = Getstorage(corpkey, account, formid + "panel");
        if (isEmpty(paneldata)) return;
        if (panel.length !== paneldata.length) return;
        for (let i = 0; i < paneldata.length; i++) {
            let item = panel.find(e => e.id === paneldata[i].id && e.type === paneldata[i].type);
            if (isEmpty(item)) return;
            paneldata[i].name = item.name;
            paneldata[i].name2 = item.name2;
            paneldata[i].abbr = item.abbr;
        }
        setpanel(paneldata);
    }
    function RestoreBase(fields) {
        const baseinfo = Getstorage(corpkey, account, statusKey(G_id.BASE));
        if (isEmpty(baseinfo)) return;
        let newdata = [];
        for (let i = 0; i < baseinfo.length; i++) {
            let item = fields.find(e => e.table === baseinfo[i].table && e.columnid === baseinfo[i].columnid);
            if (isEmpty(item)) return;
            newdata.push(item);
        }
        settextfields(newdata);
    }
    //レイアウト登録
    function SaveLayout(layoutid) {
        let coldef = [];
        for (let p = 0; p < panel.length; p++) {
            var cols = [];
            switch (panel[p].id) {
                case G_id.BASE:
                    let fds = textfields.filter(x => !x.hide);
                    for (let f = 0; f < fds.length; f++) {
                        cols.push({ headerName: fds[f].columnnm, table: "d_prod", field: fds[f].columnid });
                    }
                    break;
                case G_id.ROW:
                    cols = AGRef.current.GetshownColDef(apirow.column);
                    break;
                default:
                    continue;
            }
            for (let i = 0; i < cols.length; i++) {
                let col = DeepCopy(cols[i]);
                col.type = tabletype(p.id);
                coldef.push(col);
            }
        }
        fnc.current.postaxios('product/SaveLayout',
            {
                code: layoutid,
                coldef: coldef,
                panel: panel
            },
            {
                onSuccess: function (data) {
                    let newlayout = { value: layoutid, label: layoutid };
                    dispatch(addentrylayout(newlayout));
                    fnc.current.success();
                    fnc.current.wait(false);
                },
            }
        )
    }
    //レイアウト削除
    function DeleteLayout(layoutid) {
        fnc.current.postaxios('product/DeleteEntryLayout',
            {
                controller: controller,
                subkey: subkey,
                code: layoutid,
            },
            {
                onSuccess: function (data) {
                    let newlayout = mainlayout.filter(function (val) { return val.value !== layoutid; });
                    dispatch(setentrylayout(newlayout));
                    if (data.request !== maininitlayout)
                        dispatch(setentrystartup({
                            prelayout: mainprelayout,
                            initlayout: " ",
                            fitColumn: false
                        }));
                    fnc.current.success();
                    fnc.current.wait(false);
                },
            }
        )
    }
    //レイアウト呼び出し
    function CallLayout(layoutid) {
        fnc.current.postaxios('common/LoadLayout',
            {
                controller: controller,
                subkey: subkey,
                code: layoutid,
            },
            {
                onSuccess: function (data) {
                    setpanel(data.panels);
                    settextfields(data.columns.filter(e => e.logpid === G_id.BASE));
                    //列情報初期化
                    colRef.current = null;
                    setglobaldata(formid + "entry_" + G_id.ROW, true);
                    setcolumns(data.columns);
                    fnc.current.wait(false);
                },
            }
        )
    }

    function panelhidden(p) {
        if (isEmpty(p)) return false;
        if (EmptyPanel(p.id, p.type)) return true;
        if (p.id === G_id.ROW && rowmode === 1) return true;
        if (p.id === G_id.CALC1 && rowmode === 0) return true;
        if (p.id === G_id.CALC2 && rowmode === 0) return true;
        if (p.id === G_id.CALC1 && calckubun === "2") return true;
        if (p.id === G_id.CALC2 && calckubun === "1") return true;
        return p.hide;
    }
    //パネルセレクタ
    function panelnavwidth() {
        return windowDimensions.width - 280;
    }

    //リストレイアウト適用
    function SetLayout(newcol, type) {
        let newfields = DeepCopy(textfields.filter(e => e.type !== type));
        for (let i = 0; i < newcol.length; i++) {
            let column = textfieldsall.find(e => e.columnid === newcol[i]);
            newfields.push(column);
        }
        settextfields(newfields);
    }

    //panel入れ替え
    const onPanelSortEnd = ({ oldIndex, newIndex }) => {
        let items = panel.filter(e => !panelhidden(e));
        let oldidx = panel.findIndex(e => e.type === items[oldIndex].type);
        let newidx = panel.findIndex(e => e.type === items[newIndex].type);
        setpanel(arrayMove(panel, oldidx, newidx));
    };

    const SortablePanelItem = SortableElement(({ pnl }) => (
        <ListItem className="minwidth0">
            <Chip
                label={pnl.abbr}
                title={pnl.name}
                size="small"
                onClick={() => Jump(pnl.id, pnl.type)}
            />
        </ListItem>
    ));
    const SortablePanelSelector = SortableContainer(({ items }) => {
        var newitem = [];
        for (let i = 0; i < items.length; i++) {
            if (!panelhidden(items[i])) newitem.push(items[i]);
        }
        return (
            <ul style={{ display: 'flex' }}  >
                {newitem.map((value, index) => (
                    <SortablePanelItem key={`item-${index}`} index={index} pnl={value} disabled={layoutlock}/>
                ))}
            </ul>
        );
    });
    function Contents(props) {
        if (props.panel.id === "0") {
            const baseid = "basepanel" + props.panel.type;
            return (
                <div id={baseid} >
                    <EntryBase
                        fnc={fnc}
                        textfields={textfields}
                        settextfields={settextfields}
                        panel={props.panel}
                        ValueChanged={ValueChanged}
                        entrydataRef={entrydataRef}
                        layoutlock={layoutlock}
                    />
                </div>
            );
        }
        if (props.panel.id === G_id.ROW ) {
            return (
                <React.Fragment>
                    <EntryGrid
                        id={props.panel.id}
                        elemid="rowGrid"
                        entrydataRef={entrydataRef}
                        dataRef={rowsRef}
                        columnRef={colRef}
                        columninfo={columninfo}
                        columns={columns}
                        sortable={true}
                        modifyRef={modifyRef}
                        type={tabletype(G_id.ROW)}
                        fnc={fnc}
                        onFirstDataRendered={onFirstDataRendered}
                        statusKey={formid + "entry_" + G_id.ROW}
                        ValueChanged={ChangeRowValue}
                        RowValueChanged={RowValueChanged}
                        ColdefSpecial={ColdefSpecial}
                        QueryRemoveRow={QueryRemoveRow}
                        SetTriggerfield={SetTriggerfield}
                    />
                </React.Fragment>
            );
        }
        if (props.panel.id === G_id.CALC1 ) {
            return (
                <React.Fragment>
                    <EntryGrid
                        id={props.panel.id}
                        elemid="calc1Grid"
                        entrydataRef={entrydataRef}
                        dataRef={calc1Ref}
                        columnRef={calc1colRef}
                        columninfo={columninfo}
                        columns={columns}
                        sortable={true}
                        modifyRef={modifyRef}
                        type={tabletype(G_id.CALC1)}
                        fnc={fnc}
                        onFirstDataRendered={onFirstDataRendered}
                        statusKey={formid + "entry_" + G_id.CALC1}
                        ValueChanged={(p) => ChangeCalcValue(0, p)}
                        rowContext={1}
                   />
                </React.Fragment>
            );
        }
        if (props.panel.id === G_id.CALC2) {
            return (
                <React.Fragment>
                    <EntryGrid
                        id={props.panel.id}
                        elemid="calc2Grid"
                        entrydataRef={entrydataRef}
                        dataRef={calc2Ref}
                        columnRef={calc2colRef}
                        columninfo={columninfo}
                        columns={columns}
                        sortable={true}
                        modifyRef={modifyRef}
                        type={tabletype(G_id.CALC2)}
                        fnc={fnc}
                        onFirstDataRendered={onFirstDataRendered}
                        statusKey={formid + "entry_" + G_id.CALC2}
                        ValueChanged={(p) => ChangeCalcValue(1,p)}
                        rowContext={1}
                    />
                </React.Fragment>
            );
        }
        return null;

    }
    function EntryForm() {
        return (
            <div style={{ padding: '5px 15px', height: '100%', overflow: 'auto', backgroundColor: '#D8D8D8' }} ref={EntrybodyRef}>
                {panel.map((p, i) => {
                    return (
                        <Box
                            display={panelhidden(p) ? "none" : "flex"}
                            justifyContent="space-around"
                            alignItems="center"
                            padding="5px"
                        >
                            <Paper
                                style={{
                                    width: '100%',
                                    height: 'auto',
                                    padding: 10
                                }}
                            >
                                <div style={{ position: 'relative', marginBottom: 5 }}>
                                    {p.name === '' ? <div style={{ display: 'inline-block', height: 10 }}></div> : p.name}
                                    {p.name2 !== '' ? '-' : ''}
                                    <span style={{ fontStyle: 'oblique' }}>{p.name2}</span>
                                    {p.id !== '0' || layoutlock ? null :
                                        <div style={{ position: 'absolute', right: 40, top: -3 }} title="項目設定">
                                            <IconButton size="small" onClick={() => SetBaseField(p.type)}  >
                                                <Icon style={{ fontSize: 16 }}>settings_applications</Icon>
                                            </IconButton>
                                        </div>
                                    }
                                    {p.id === '1' || p.id === '2' || (p.id === '3' && calckubun === '2') ?
                                        <div style={{ position: 'absolute', left: 150, top: -8 }}>
                                            <Button size="small" onClick={Calculate}
                                                style={{
                                                    width: 150, backgroundColor: themestyle.body.back === '#F8F8F8' ? themestyle.maincolor : "#F2F0ED",
                                                    color: themestyle.body.back === '#F8F8F8' ? '#FFF' : '#333', fontWeight: 700
                                                }}
                                            >
                                                計算実行
                                            </Button>
                                        </div>
                                        :null
                                    }
                                    {p.id === '2' || p.id === '3' ?
                                        <React.Fragment>
                                            <div style={{ position: 'absolute', left: 350, top: -7 }}>
                                                <Button size="small" onClick={()=>SetQuantity(p.id)}
                                                    style={{
                                                        width: 100, backgroundColor: themestyle.body.back === '#F8F8F8' ? themestyle.maincolor : "#F2F0ED",
                                                        color: themestyle.body.back === '#F8F8F8' ? '#FFF' : '#333', fontWeight: 700
                                                    }}
                                                >
                                                    発注数算出
                                                </Button>
                                            </div>
                                            <div style={{ position: 'absolute', left: 470, top: -7 }}>
                                                <FormControlLabel
                                                    control={<Checkbox size="small" color="default" inputRef={p.id === '2' ? check1Ref : check2Ref} />}
                                                    label={<span className={classes.label} >選択行のみ</span>}
                                                />
                                            </div>
                                            <div style={{ position: 'absolute', left: 600, top: 0 }}>
                                                <span style={{ fontSize: 10, marginRight:10 }} >丸め：</span>
                                                <TextField
                                                    id={"round_" + p.id}
                                                    select
                                                    hiddenLabel
                                                    defaultValue={p.id === '2' ? round[0] : round[1]}
                                                    inputRef={p.id === '2' ? round1Ref : round2Ref}
                                                    variant="standard"
                                                    size="small"
                                                    style={{ width: 80 }}
                                                    inputProps={{ style: { fontSize: 12 } }}
                                                >
                                                    <MenuItem value={0} style={{ fontSize: 12 }}>切り捨て</MenuItem>
                                                    <MenuItem value={1} style={{ fontSize: 12 }}>四捨五入</MenuItem>
                                                    <MenuItem value={2} style={{ fontSize: 12 }}>切り上げ</MenuItem>
                                                </TextField>
                                                <span style={{ fontSize: 10, marginLeft:20, marginRight: 10 }} >小数桁：</span>
                                                <TextField
                                                    id={"degit_" + p.id}
                                                    select
                                                    hiddenLabel
                                                    defaultValue={p.id === '2' ? degitpos[0] : degitpos[1]}
                                                    inputRef={p.id === '2' ? degitpos1Ref : degitpos2Ref}
                                                    variant="standard"
                                                    size="small"
                                                    style={{ width: 50 }}
                                                    inputProps={{ style: { fontSize: 12 } }}
                                                >
                                                    <MenuItem value={0} style={{ fontSize: 12 }}>0</MenuItem>
                                                    <MenuItem value={1} style={{ fontSize: 12 }}>1</MenuItem>
                                                    <MenuItem value={2} style={{ fontSize: 12 }}>2</MenuItem>
                                                </TextField>
                                            </div>
                                        </React.Fragment>
                                        : null
                                    }
                                    {p.id !== '1' ? null :
                                        <div style={{ position: 'absolute', right: 100, top: -3 }}>
                                            <Button size="small" endIcon={<Icon style={{ fontSize: 16 }}>arrow_forward</Icon>} onClick={rowmodeChange}>
                                                {"材料計算"}
                                            </Button>
                                        </div>
                                    }
                                    {p.id <= '1' ? null :
                                        <div style={{ position: 'absolute', right: 100, top: -3 }}>
                                            <Button size="small" endIcon={<Icon style={{ fontSize: 16 }}>arrow_forward</Icon>} onClick={rowmodeChange}>
                                                {"製品選択"}
                                            </Button>
                                        </div>
                                    }
                                    {layoutlock || sectionclose ? null :
                                        <div style={{ position: 'absolute', right: 10, top: -3 }}>
                                            <IconButton size="small" onClick={() => showpanel(p.id, p.type, false)}  >
                                                <Icon style={{ fontSize: 16 }}>close</Icon>
                                            </IconButton>
                                        </div>
                                    }
                                </div>
                                <Contents panel={p} rowmode={rowmode} />
                            </Paper >
                        </Box>
                    );
                })}
            </div>
        );
    }

    return (
        <div>
            <ComFunc ref={fnc} />
            <MasterBase
                formid={formid}
                controller={controller}
                subkey={subkey}
                location={props.location}
                actionurl={actionurl}
                entrycallback={MenuAction}
                queryaction={MenuQueryAction}
                condition={true}
                entryform={true}
                tabs={true}
                show={Show}
                primaryid={'d_calc'}
                primarykey={primarykeys}
                parentedit={true}
                navmenu={formlock ? navmenu.filter(e => e.menuid !== 'formupload') : navmenu}
                suppressaction={suppressaction}
                slipsave={true}
            >
                <EntryForm />
            </MasterBase>
            <EntryLayout
                columninfo={textfieldsall}
                textfields={textfields}
                onAppry={SetLayout}
            />
            {formstatus === 'NEW FORM' || formstatus === 'ENTRY FORM' || formstatus === 'COPY FORM' ?
                <div>
                    <div style={{ position: 'absolute', top: 60, right: 15 }}>
                        <IconButton size="small" onClick={() => fnc.current.entrysettingopen()} title={"レイアウト設定"} >
                            <Icon>table_chart</Icon>
                        </IconButton>
                    </div>
                    <Headline columninfo={columninfo} entrydata={entrydataRef.current} ></Headline>
                    <div style={{ position: 'absolute', top: 60, left: 210 }}>
                        <Paper
                            sx={{
                                display: 'flex',
                                justifyContent: 'center',
                                flexWrap: 'wrap',
                                listStyle: 'none',
                                p: 0.2,
                                m: 0,
                            }}
                            component="ul"
                            elevation={0}
                            style={{ backgroundColor: "transparent", width: panelnavwidth() }}
                        >
                            {/*Panel Selector*/}
                            <SortablePanelSelector
                                axis={"x"}
                                items={panel}
                                onSortEnd={onPanelSortEnd}
                                distance={2}
                            />
                        </Paper>
                    </div>
                </div>
                : null}
            <AGFunc ref={AGRef} />
            <EntrySetting
                formid={formid}
                controller={controller}
                subkey={subkey}
                savelayout={SaveLayout}
                deletelayout={DeleteLayout}
                calllayout={CallLayout}
                panels={panel}
                showpanel={showpanel}
            />
            <DataTree code={edittingcode} />
        </div>
    );
};
